import { AugmentationPanelItemProps } from "@pathwright/ux/src/components/augmentation/AugmentationPanelSection"
import { isEmpty } from "@pathwright/ux/src/components/texteditor/utils"
import { useMemo } from "react"
import { useCoverPageContext } from "../CoverPageProvider"
import { CoverPagePanelSection } from "../types"
import { useCoverPageTranslate } from "../utils"
import { requestCoverPageInlineSectionEdit } from "./CoverPageInlineSectionEditor"
import { CoverPagePanelSectionBlock } from "./CoverPagePanelSection"
import { useCoverPageAddLabel } from "./addLabels"

export function CoverPagePanelPitchSection() {
  const resource = useCoverPageContext((value) => value.resource)
  const { t } = useCoverPageTranslate()
  const addOverviewLabel = useCoverPageAddLabel("overview")
  const addPreviewLabel = useCoverPageAddLabel("preview")

  const items: AugmentationPanelItemProps[] = useMemo(
    () => [
      {
        itemKey: "edit-title-images",
        icon: "image",
        label: t("panel_pitch.edit_title_images", {
          defaultValue: "Edit header title, images..."
        }),
        panelRoute: "/header"
      },
      {
        itemKey: "edit-description",
        icon: "edit",
        label: !isEmpty(resource?.description)
          ? t("panel_pitch.edit_overview", { defaultValue: "Edit overview..." })
          : addOverviewLabel,
        hashKey: "description",
        onClick: () =>
          requestCoverPageInlineSectionEdit(CoverPagePanelSection.Description)
      },
      {
        itemKey: "add-steps-to-preview",
        icon: "plus",
        label: addPreviewLabel,
        panelRoute: "/preview",
        hashKey: "preview"
      }
    ],
    [resource?.description, t, addOverviewLabel, addPreviewLabel]
  )

  return (
    <CoverPagePanelSectionBlock
      heading={t("panel_sections.content", { defaultValue: "Content" })}
      sectionKey="header"
      items={items}
    />
  )
}
